import React from 'react'

import { Text } from '@wartek-id/text-v1'

type TugasPokokItemProps = {
  title: string
  subItems: string[]
}

const TugasPokokItem = (props: TugasPokokItemProps) => {
  return (
    <div className="space-y-6">
      <Text variant="subheading" className="uppercase">
        {props.title}
      </Text>
      <div className="space-y-6">
        {props.subItems.map((item, index) => (
          <div
            key={index}
            className="rounded-lg border border-subdued p-6 flex gap-6"
          >
            <Text variant="heading-sm" color="informational">
              {index + 1}.
            </Text>
            <Text variant="body" className="text-justify">
              {item}
            </Text>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TugasPokokItem
